var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagedCompaniesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 18.3334H4.16675C2.50008 18.3334 1.66675 17.5001 1.66675 15.8334V9.16675C1.66675 7.50008 2.50008 6.66675 4.16675 6.66675H8.33342V15.8334C8.33342 17.5001 9.16675 18.3334 10.8334 18.3334Z",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42507 3.33325C8.3584 3.58325 8.33341 3.85825 8.33341 4.16659V6.66659H4.16675V4.99992C4.16675 4.08325 4.91675 3.33325 5.83341 3.33325H8.42507Z",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 6.66675V10.8334",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.66675V10.8334",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 14.1667H12.5001C12.0417 14.1667 11.6667 14.5417 11.6667 15.0001V18.3334H15.0001V15.0001C15.0001 14.5417 14.6251 14.1667 14.1667 14.1667Z",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.8333V14.1666",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 15.8334V4.16675C8.33325 2.50008 9.16659 1.66675 10.8333 1.66675H15.8333C17.4999 1.66675 18.3333 2.50008 18.3333 4.16675V15.8334C18.3333 17.5001 17.4999 18.3334 15.8333 18.3334H10.8333C9.16659 18.3334 8.33325 17.5001 8.33325 15.8334Z",
    stroke: "#7E84A3",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagedCompaniesIcon);
export default __webpack_public_path__ + "static/media/managed-companies-icon.e790ad8f70ee8a8da7da1c65ea467287.svg";
export { ForwardRef as ReactComponent };